import { render } from "./step3.vue?vue&type=template&id=9236bd02&scoped=true"
import script from "./step3.vue?vue&type=script&lang=ts"
export * from "./step3.vue?vue&type=script&lang=ts"

import "./step3.vue?vue&type=style&index=0&id=9236bd02&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9236bd02"

export default script